
import Vue from 'vue';
import {mapActions, mapGetters, mapMutations} from 'vuex';
import ILocationSearchType from '../interfaces/ilocation-search-type';

declare const Alkami: any;

export default Vue.extend({
  name: 'location-type-filter',
  data() {
    return {
      Alkami,
      locationSearchTypes: [] as ILocationSearchType[]
    };
  },
  computed: {
    ...mapGetters(['getAllLocationSearchTypes'])
  },
  watch: {
    getAllLocationSearchTypes(value: ILocationSearchType[]) {
      this.locationSearchTypes = value;
    }
  },
  methods: {
    ...mapMutations(['setLocationSearchTypes', 'setCurrentPageNumber']),
    ...mapActions(['getFiByGeoLocationsAsync']),
    async applyFilters() {
      this.setLocationSearchTypes(this.locationSearchTypes);
      this.setCurrentPageNumber(1);
      await this.getFiByGeoLocationsAsync();
    },
    clearFilters() {
      this.locationSearchTypes.forEach((lst: ILocationSearchType) => lst.Checked = false);
      this.setLocationSearchTypes(this.locationSearchTypes);
    }
  }
});
